
/* eslint-disable consistent-return */
import objectEach from 'fast-loops/lib/objectEach';
import { RULE_TYPE, KEYFRAME_TYPE, FONT_TYPE, STATIC_TYPE, CLEAR_TYPE, getRuleScore, generateCSSRule } from 'fela-utils';

import getNodeFromCache from './getNodeFromCache';
import insertRule from './insertRule';

export default function createSubscription(renderer) {
  return function (change) {
    if (change.type === CLEAR_TYPE) {
      objectEach(renderer.nodes, function (_ref) {
        var node = _ref.node;
        return node.parentNode.removeChild(node);
      });

      renderer.nodes = {};
      return;
    }

    var node = getNodeFromCache(change, renderer);

    switch (change.type) {
      case KEYFRAME_TYPE:
        node.textContent += change.keyframe;
        break;
      case FONT_TYPE:
        node.textContent += change.fontFace;
        break;
      case STATIC_TYPE:
        node.textContent += change.selector ? generateCSSRule(change.selector, change.css) : change.css;
        break;
      case RULE_TYPE:
        insertRule(change, renderer, node);
        break;
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/es/dom/connection/createSubscription.js
// module id = 1158
// module chunks = 0